import script from "./TankStatusChart.vue?vue&type=script&setup=true&lang=js"
export * from "./TankStatusChart.vue?vue&type=script&setup=true&lang=js"

import "./TankStatusChart.vue?vue&type=style&index=0&id=a79e71aa&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Justin\\OneDrive\\OMNIA\\Clients\\R3\\Repos\\R3_vue_web_app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a79e71aa"]])

export default __exports__